import React, { Component } from 'react';
import { Button } from 'wix-style-react';

import ControlPanel from './ControlPanelWrapper/ControlPanelWrapper';
import TextInputControl from './TextInput/TextInput';
import TextInputIndustryMobile from './TextInput/TextInputIndustryMobile';
import s from './mobileControls.scss';

export class MobileControls extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentEditingField: ''
    };
  }

  handleIndustrySelected = industry => {
    const { onIndustryChange } = this.props;
    onIndustryChange(industry.id, industry.label, false);
  };

  handleDone = () => {
    const { onSearch } = this.props;
    this.clearEditing();
    onSearch();
  };

  clearEditing = () => {
    this.setState(() => {
      return {
        currentEditingField: ''
      };
    });
  };

  handleBusinessIdeaChange = e => {
    const { onBusinessIdeaChange } = this.props;
    onBusinessIdeaChange(e.target.value);
  };

  editName = () => {
    this.setState(() => {
      return {
        currentEditingField: 'businessIdea'
      };
    });
  };

  editIndustry = () => {
    this.setState(() => {
      return {
        currentEditingField: 'industry'
      };
    });
  };

  handleIndustryNameChanged = text => {
    const { onIndustryChange } = this.props;
    onIndustryChange(text, text, true);
  };

  render() {
    const { currentEditingField } = this.state;
    const { businessIdea, t, onBusinessIdeaChange, industry, industriesFetcher } = this.props;
    return [
      <ControlPanel
        onClickOutside={this.clearEditing}
        key="1"
        isTop
        isHidden={currentEditingField !== 'businessIdea'}
        hideFromTop
        onDone={this.handleDone}
        t={t}
      >
        <TextInputControl
          isHidden={currentEditingField !== 'businessIdea'}
          label={t('BNG_EDIT_NAME_BUTTON')}
          onChange={onBusinessIdeaChange}
          value={businessIdea}
          autoFocus={true}
        />
      </ControlPanel>,
      <ControlPanel
        onClickOutside={this.clearEditing}
        key="2"
        isTop
        isFlex
        isHidden={currentEditingField !== 'industry'}
        hideFromTop
        large
        onDone={this.handleDone}
        t={t}
      >
        <TextInputIndustryMobile
          onChange={this.handleIndustryNameChanged}
          isHidden={currentEditingField !== 'industry'}
          label={t('BNG_EDITOR_CATEGORY_INDUSTRY')}
          value={industry.industryText}
          onIndustrySelected={this.handleIndustrySelected}
          industriesFetcher={industriesFetcher}
        />
      </ControlPanel>,
      <div key="3" className={s.container}>
        <div className={s.nameButton}>
          <Button fullWidth onClick={this.editName} priority="secondary" size="small" skin="dark">
            {t('BNG_EDIT_NAME_BUTTON')}
          </Button>
        </div>
        <div className={s.industryButton}>
          <Button fullWidth onClick={this.editIndustry} priority="secondary" size="small" skin="dark">
            {t('BNG_NAMES_LIST_EDIT_INDUSTRY_INPUT')}
          </Button>
        </div>
      </div>
    ];
  }
}

